import styled from 'styled-components'
import colors from '../../../theme/colors'

import Text from '../../../atoms/Text/Text'
import InfoCardComponent from '../../../atoms/InfoCard/InfoCard'
import SingleLineInput from '../../../atoms/SingleLineInput/SingleLineInput'

export const Wrapper = styled.div`
  padding-top: 48px;
`

export const Divider = styled.hr`
  margin-top: 38px;
  margin-bottom: 48px;
  border: 1px solid ${colors.Primary.Grey};
`

export const Fieldset = styled.fieldset`
  border: none;
  > *:not(:last-child) {
    margin-bottom: 32px;
  }
`

export const RadioButtonDetail = styled.div`
  margin-top: 8px;
  margin-left: 32px;
`

export const RadioButtonInfo = styled(Text).attrs({
  light: true,
})``

export const ErrorMessage = styled(Text)`
  color: ${colors.Action.ErrorRed};
  margin-top: 8px;
`

export const RadioButtonSingleLineInput = styled(SingleLineInput)`
  width: 100%;
  margin-top: 8px;
`

export const InfoCard = styled(InfoCardComponent)`
  margin-top: 16px;
`

export const Row = styled.div`
  display: flex;

  > *:not(:last-child) {
    margin-right: 24px;
  }
`

export const AddressInputContainer = styled.div`
  margin-top: 24px;

  > *:not(:last-child) {
    margin-bottom: 24px;
  }
`
